import { createEntityAdapter } from '@ngrx/entity';
import { roleActions } from '../actions';
export const roleAdapter = createEntityAdapter({
    selectId: (item) => item.id,
    sortComparer: sortByName
});
export const INIT_STATE = roleAdapter.getInitialState({
    loaded: false,
    loading: false
});
export function sortByName(a, b) {
    return a.name.localeCompare(b.name);
}
export function reducer(state = INIT_STATE, action) {
    switch (action.type) {
        case roleActions.LOAD: {
            return {
                ...state,
                loading: true
            };
        }
        case roleActions.LOAD_BY_ID_SUCCESS:
        case roleActions.LOAD_SUCCESS: {
            return {
                ...roleAdapter.addMany(action.payload, state),
                loaded: true,
                loading: false
            };
        }
        case roleActions.LOAD_BY_ID_FAILED:
        case roleActions.LOAD_FAILED: {
            return {
                ...state,
                loaded: false,
                loading: false
            };
        }
        case roleActions.UPDATE_SUCCESS: {
            return roleAdapter.updateOne({
                id: action.payload.id,
                changes: action.payload
            }, state);
        }
        case roleActions.CREATE_SUCCESS: {
            return roleAdapter.addOne(action.payload, state);
        }
        case roleActions.DELETE_SUCCESS: {
            return roleAdapter.removeOne(action.payload, state);
        }
        case roleActions.CREATE_FAILED:
        case roleActions.DELETE_FAILED:
        case roleActions.UPDATE_FAILED: {
            return { ...state, loading: false };
        }
        default: {
            return state;
        }
    }
}
export const getRolesLoaded = (state) => state.loaded;
export const getRolesLoading = (state) => state.loading;
//# sourceMappingURL=role.js.map